
import { Link } from 'react-router-dom';
import videos from "./data.json"



const TeacherVideos = () => {

    const filtered_videos = videos.filter(video => video.type == "teacher")

    return (  
        <div className="allvideos">
            <h1>Teacher Videos</h1>


            {filtered_videos && filtered_videos.map((video) => (
                <div className="repo-preview" key={video.id}>
                    <Link to={`/allvideos/${video.id}`}>
                    <h2>{video.title}</h2>
                    </Link>

                </div>
            ))}
        </div>
    );

}

export default TeacherVideos;